import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { Toaster } from "@/components/ui/sonner";
import { trackPageView } from "@/lib/analytics";
import { demoNotice } from "@/data/site";

const useAnalytics = () => {
  const location = useLocation();
  const first = useRef(true);

  // SPA page_view on route change (initial load is sent by gtag config).
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location]);

  // Demo site: intercept contact/appointment-style links (call, text, email, directions)
  // and show the portfolio notice instead of performing the action.
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest ? e.target.closest("a") : null;
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (
        href.startsWith("tel:") ||
        href.startsWith("sms:") ||
        href.startsWith("mailto:") ||
        href.includes("/maps/dir")
      ) {
        e.preventDefault();
        window.alert(demoNotice);
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
};

export const Layout = () => {
  useAnalytics();
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="grain relative min-h-screen bg-[var(--bg)]">
        <Header />
        <main className="relative z-10">
          <Outlet />
        </main>
        <Footer />
        <StickyMobileCTA />
        <div className="h-16 md:hidden" aria-hidden />
        <Toaster position="top-center" />
      </div>
    </ReactLenis>
  );
};
